import { ReactNode } from 'react';

import { Main } from 'modules/App/Main';
import { NotFound } from 'modules/App/NotFound';
import { Documents } from 'modules/account/documents';
import { CreateOrder } from 'modules/account/orderModule/createOrder';
import { Order } from 'modules/account/orderModule/order';
import { Orders } from 'modules/account/orderModule/orders';
import { Agreement } from 'modules/agreement';
import { Login } from 'modules/auth/login';
import { LoginByToken } from 'modules/auth/loginByToken';
import { Registration } from 'modules/auth/registration';
import { RestorePassword } from 'modules/auth/restorePassword';
import { OnboardingInfo } from 'modules/onboarding/onboardingInfo';
import { OnboardingRoutes } from 'modules/onboarding/routes';
import { ChangePassword } from 'modules/user/changePassword';
// eslint-disable-next-line no-restricted-imports
import { Navigate } from 'react-router-dom';

import { ROUTES } from '../routes';

import { RoutesId } from './routesId';

// Define a mapping of route IDs to React components or elements
export const PAGES: Record<RoutesId, ReactNode> = {
  [RoutesId.root]: <Main />,
  [RoutesId.notFound]: <NotFound />,
  [RoutesId.home]: <Navigate replace to={ROUTES.account.orders.fullPath} />,
  [RoutesId.registration]: <Registration />,
  [RoutesId.login]: <Login />,
  [RoutesId.loginByToken]: <LoginByToken />,
  [RoutesId.onboarding]: <OnboardingRoutes />,
  [RoutesId.onboardingInfo]: <OnboardingInfo />,
  [RoutesId.restorePassword]: <RestorePassword />,
  [RoutesId.changePassword]: <ChangePassword />,

  [RoutesId.account]: <Navigate replace to={ROUTES.account.orders.fullPath} />,
  [RoutesId.orders]: <Orders />,
  [RoutesId.order]: <Order />,
  [RoutesId.createOrder]: <CreateOrder />,
  [RoutesId.documents]: <Documents />,
  [RoutesId.agreement]: <Agreement />,
};
